import { Provider } from '@angular/core';
import { OtpRepository } from './domain/otp.repository';
import { OtpHttpRepository } from './infrastructure/repository/otp-http.repository';
import { OtpStateService } from './presentation/service/otp-state.service';
import { OtpService } from './presentation/service/otp.service';

/**
 * Registers all OTP feature providers:
 * - OtpRepository → OtpHttpRepository (infrastructure)
 * - OtpStateService (shared state between service and modal)
 * - OtpService (orchestration layer)
 */
export function provideOtpRepository(): Provider[] {
  return [
    {
      provide: OtpRepository,
      useClass: OtpHttpRepository,
    },
    OtpStateService,
    OtpService,
  ];
}
